import { render, staticRenderFns } from "./JsonComparison.vue?vue&type=template&id=91be805e&scoped=true"
import script from "./JsonComparison.vue?vue&type=script&lang=js"
export * from "./JsonComparison.vue?vue&type=script&lang=js"
import style0 from "./JsonComparison.vue?vue&type=style&index=0&id=91be805e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91be805e",
  null
  
)

export default component.exports